module.exports = "https://cdn-b2c.dom.ru/b2c-domru/2.357.4/frontend/_next/static/images/bg-1-f3fd1cc671f9b6a2e0ff46e45421303c.png";